import { createSlice } from "@reduxjs/toolkit";
//@ts-ignore
import { getAllWholesalerCommunity, getAllWholesalerCommunityWithoughtId, getCommunityById, getCommunityList } from "./ThunkActions";
// @ts-ignore
import { iCommunityState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iCommunityState = {
  isLoading: false,
  communityDetail: null, // Ensure this is a single object
  communityList:[],
  errorMessage: null,
  wholesalerCommunity:[],
  wholesalerCommunityById:[]
};
export const communitySlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetCommunityState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommunityById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCommunityById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.communityDetail = payload.data.community;
          state.isLoading = false;
        }
      })
      .addCase(getCommunityById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Community data";
        state.isLoading = false;
      })
      .addCase(getCommunityList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCommunityList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.communityList = payload.data.communities; 
          state.isLoading = false;
        }
      })
      .addCase(getCommunityList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Community data";
        state.isLoading = false;
      })

      //get wholesaler community list
      .addCase(getAllWholesalerCommunity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWholesalerCommunity.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.wholesalerCommunityById = payload.data.communities; 
          state.isLoading = false;
        }
      })
      .addCase(getAllWholesalerCommunity.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Community data";
        state.isLoading = false;
      })

		  
      //get wholesaler community getAllWholesalerCommunityWithoughtId
      .addCase(getAllWholesalerCommunityWithoughtId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWholesalerCommunityWithoughtId.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.wholesalerCommunity = payload.data.communities; 
          state.isLoading = false;
        }
      })
      .addCase(getAllWholesalerCommunityWithoughtId.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Community data";
        state.isLoading = false;
      });

       
  },
});

export const { resetCommunityState } = communitySlice.actions;
export default communitySlice.reducer;